import React from 'react';
import { Typography } from 'antd';
import LoginForm from '@containers/auth/LoginForm';
import './Login.less';

const { Title } = Typography;

export default function LoginPage() {
  return (
    <div className="login">
      <Title level={2}>Login</Title>
      <div className="login__form-container">
        <LoginForm />
      </div>
    </div>
  );
}
